(() => {
  const KEY = "siteLoaderShown_v1";
  const FAILSAFE_MS = 2200;

  function revealPageAndRemoveLoader(loader) {
    // Mark as shown forever
    try { localStorage.setItem(KEY, "1"); } catch (e) {}

    // Reveal page
    document.documentElement.classList.remove("preloading");
    document.documentElement.classList.add("preloaded");
    document.body.style.overflow = "";

    // Remove loader from DOM (best for scroll performance)
    if (loader && loader.parentNode) loader.parentNode.removeChild(loader);
  }

  document.addEventListener("DOMContentLoaded", () => {
    const loader = document.querySelector(".loader");
    if (!loader) return;

    // If not in preloading mode, remove loader instantly
    if (!document.documentElement.classList.contains("preloading")) {
      revealPageAndRemoveLoader(loader);
      return;
    }

    // Reduced motion: skip animation
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      revealPageAndRemoveLoader(loader);
      return;
    }

    // Failsafe: never block user
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      revealPageAndRemoveLoader(loader);
    };
    const failsafe = setTimeout(finish, FAILSAFE_MS);

    // If GSAP missing, do a simple CSS fade
    if (typeof window.gsap === "undefined") {
      loader.style.transition = "opacity 220ms ease";
      loader.style.opacity = "0";
      setTimeout(() => {
        clearTimeout(failsafe);
        finish();
      }, 240);
      return;
    }

    // LOGO should already be visible due to CSS.
    // Now do a quick "polish" animation and exit.
    const tl = gsap.timeline({
      defaults: { ease: "power2.out" },
      onComplete: () => {
        clearTimeout(failsafe);
        finish();
      },
      onInterrupt: () => {
        clearTimeout(failsafe);
        finish();
      }
    });

    // Small logo pop (fast)
    tl.fromTo(
      ".loader .word img, .loader img",
      { scale: 0.98, opacity: 1 },
      { scale: 1, duration: 0.25 }
    );

    // Optional: tiny divider animation if exists
    if (document.querySelector(".divider")) {
      tl.fromTo(".divider", { scaleY: 0 }, { scaleY: 1, duration: 0.18 }, "<");
    }

    // Loader exit (fade + slight lift)
    tl.to(loader, { opacity: 0, y: -6, duration: 0.22 }, "+=0.10");
  });
})();